import React from 'react';
import './EcalAlert.css';


export const ecalAlert = (showEcalAlert: boolean) => {
    if (!showEcalAlert) {
        return;
    }
    const alertMessage = 'The "Sync to Calendar" feature on invoices will no longer available for use. Sorry for any inconvenience this may cause.'
    return (<div className="myob ng-scope">
            <div className="alert_mobile_invoice_ecal alert_invoice_ecal alert alert-danger" id="alert">
                <img className="information-icon" src={require('../../assets/icons/alert-danger.svg').default}></img>
                <span className="information-message alert_message_invoice_ecal">{alertMessage}</span>
            </div>
        </div>
    )
}
